// extracted by mini-css-extract-plugin
export default {"reportTitle":"ReportDetails_reportTitle__T02u-","reportContent":"ReportDetails_reportContent__7Dkq9","summaryTitle":"ReportDetails_summaryTitle__exnem"};